// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay-box[data-v-345ec094] {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.overlay-box .overlay-border[data-v-345ec094] {\n    display: flex;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 1px dashed #666666;\n}\n.overlay-box .overlay-border .overlay-label[data-v-345ec094] {\n      margin-left: auto;\n      margin-right: auto;\n      align-self: center;\n      font-size: 28px;\n      font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
